var _defs, _g, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerificationPointOneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#0d0d0d;}.b{fill:#0d0d0d;font-size:16px;font-family:Helvetica-Bold, Helvetica;font-weight:700;}.c{stroke:none;}.d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 12,
    cy: 12,
    r: 11.5
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "b",
    transform: "translate(8 18)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationPointOneIcon);
export default __webpack_public_path__ + "static/media/verification-point-one-icon.a67a44f3b3431a89ac8257dc92676875.svg";
export { ForwardRef as ReactComponent };